export default __webpack_public_path__ + "static/media/planet.36d0f86f.gif";